import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { NHIEMVUCANHAN } from '../constants';
import { Get } from '../../utils/httpProvider';
import { NHIEMVUCANHAN_API } from '../../utils/apiUrl';
import { createUrlWithParam } from '../../utils/helper';

// ---------------------------
// Thunks
// ---------------------------
export const nhiemVuCaNhanDebugCurrentUserAction = createAsyncThunk(
  NHIEMVUCANHAN.DEBUG_CURRENT_USER,
  async (_, { rejectWithValue }) => {
    try {
      const data = await Get(NHIEMVUCANHAN_API.DEBUG_CURRENT_USER, null, null);
      if (!data) return rejectWithValue('Không lấy được thông tin người dùng hiện tại');
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const nhiemVuCaNhanGetProjectTasksAction = createAsyncThunk(
  NHIEMVUCANHAN.GET_PROJECT_TASKS,
  async (params, { rejectWithValue }) => {
    try {
      let url = NHIEMVUCANHAN_API.GET_PROJECT_TASKS;
      if (params && Object.keys(params).length > 0) url = createUrlWithParam(url, params);
      const data = await Get(url, null, null);
      if (!data) return rejectWithValue('Không lấy được danh sách công việc dự án');
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const nhiemVuCaNhanGetOtherTasksAction = createAsyncThunk(
  NHIEMVUCANHAN.GET_OTHER_TASKS,
  async (params, { rejectWithValue }) => {
    try {
      let url = NHIEMVUCANHAN_API.GET_OTHER_TASKS;
      if (params && Object.keys(params).length > 0) url = createUrlWithParam(url, params);
      const data = await Get(url, null, null);
      if (!data) return rejectWithValue('Không lấy được danh sách nhiệm vụ khác');
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

// NEW: Yêu cầu cá nhân
export const nhiemVuCaNhanGetYeuCauTasksAction = createAsyncThunk(
  NHIEMVUCANHAN.GET_YEU_CAU_TASKS,
  async (params, { rejectWithValue }) => {
    try {
      let url = NHIEMVUCANHAN_API.GET_YEU_CAU_TASKS;
      if (params && Object.keys(params).length > 0) url = createUrlWithParam(url, params);
      const data = await Get(url, null, null);
      if (!data) return rejectWithValue('Không lấy được danh sách xử lý yêu cầu cá nhân');
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

// NEW: Hỗ trợ cá nhân
export const nhiemVuCaNhanGetHoTroTasksAction = createAsyncThunk(
  NHIEMVUCANHAN.GET_HO_TRO_TASKS,
  async (params, { rejectWithValue }) => {
    try {
      let url = NHIEMVUCANHAN_API.GET_HO_TRO_TASKS;
      if (params && Object.keys(params).length > 0) url = createUrlWithParam(url, params);
      const data = await Get(url, null, null);
      if (!data) return rejectWithValue('Không lấy được danh sách hỗ trợ phần mềm cá nhân');
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

// ---------------------------
// Slice
// ---------------------------
export const nhiemVuCaNhanSlice = createSlice({
  name: NHIEMVUCANHAN.NAME_SLICE,
  initialState: {
    loadingUser: false,

    loadingProjectTasks: false,
    loadingOtherTasks: false,
    loadingYeuCauTasks: false,
    loadingHoTroTasks: false,

    errorUser: null,
    errorProjectTasks: null,
    errorOtherTasks: null,
    errorYeuCauTasks: null,
    errorHoTroTasks: null,

    currentUser: null,

    projectTasks: [],
    otherTasks: [],
    yeuCauTasks: [],
    hoTroTasks: [],
  },
  reducers: {
    clearNhiemVuCaNhanState: (state) => {
      state.loadingUser = false;

      state.loadingProjectTasks = false;
      state.loadingOtherTasks = false;
      state.loadingYeuCauTasks = false;
      state.loadingHoTroTasks = false;

      state.errorUser = null;
      state.errorProjectTasks = null;
      state.errorOtherTasks = null;
      state.errorYeuCauTasks = null;
      state.errorHoTroTasks = null;

      state.currentUser = null;

      state.projectTasks = [];
      state.otherTasks = [];
      state.yeuCauTasks = [];
      state.hoTroTasks = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // current user
      .addCase(nhiemVuCaNhanDebugCurrentUserAction.pending, (state) => {
        state.loadingUser = true;
        state.errorUser = null;
      })
      .addCase(nhiemVuCaNhanDebugCurrentUserAction.fulfilled, (state, action) => {
        state.loadingUser = false;
        state.errorUser = null;
        state.currentUser = action.payload || null;
      })
      .addCase(nhiemVuCaNhanDebugCurrentUserAction.rejected, (state, action) => {
        state.loadingUser = false;
        state.errorUser = action.payload || action.error?.message || 'Có lỗi khi lấy thông tin người dùng hiện tại';
      });

    builder
      // project tasks
      .addCase(nhiemVuCaNhanGetProjectTasksAction.pending, (state) => {
        state.loadingProjectTasks = true;
        state.errorProjectTasks = null;
      })
      .addCase(nhiemVuCaNhanGetProjectTasksAction.fulfilled, (state, action) => {
        state.loadingProjectTasks = false;
        state.errorProjectTasks = null;
        state.projectTasks = action.payload || [];
      })
      .addCase(nhiemVuCaNhanGetProjectTasksAction.rejected, (state, action) => {
        state.loadingProjectTasks = false;
        state.errorProjectTasks = action.payload || action.error?.message || 'Có lỗi khi tải công việc dự án';
      });

    builder
      // other tasks
      .addCase(nhiemVuCaNhanGetOtherTasksAction.pending, (state) => {
        state.loadingOtherTasks = true;
        state.errorOtherTasks = null;
      })
      .addCase(nhiemVuCaNhanGetOtherTasksAction.fulfilled, (state, action) => {
        state.loadingOtherTasks = false;
        state.errorOtherTasks = null;
        state.otherTasks = action.payload || [];
      })
      .addCase(nhiemVuCaNhanGetOtherTasksAction.rejected, (state, action) => {
        state.loadingOtherTasks = false;
        state.errorOtherTasks = action.payload || action.error?.message || 'Có lỗi khi tải nhiệm vụ khác';
      });

    builder
      // yeu cau tasks
      .addCase(nhiemVuCaNhanGetYeuCauTasksAction.pending, (state) => {
        state.loadingYeuCauTasks = true;
        state.errorYeuCauTasks = null;
      })
      .addCase(nhiemVuCaNhanGetYeuCauTasksAction.fulfilled, (state, action) => {
        state.loadingYeuCauTasks = false;
        state.errorYeuCauTasks = null;
        state.yeuCauTasks = action.payload || [];
      })
      .addCase(nhiemVuCaNhanGetYeuCauTasksAction.rejected, (state, action) => {
        state.loadingYeuCauTasks = false;
        state.errorYeuCauTasks = action.payload || action.error?.message || 'Có lỗi khi tải xử lý yêu cầu cá nhân';
      });

    builder
      // ho tro tasks
      .addCase(nhiemVuCaNhanGetHoTroTasksAction.pending, (state) => {
        state.loadingHoTroTasks = true;
        state.errorHoTroTasks = null;
      })
      .addCase(nhiemVuCaNhanGetHoTroTasksAction.fulfilled, (state, action) => {
        state.loadingHoTroTasks = false;
        state.errorHoTroTasks = null;
        state.hoTroTasks = action.payload || [];
      })
      .addCase(nhiemVuCaNhanGetHoTroTasksAction.rejected, (state, action) => {
        state.loadingHoTroTasks = false;
        state.errorHoTroTasks = action.payload || action.error?.message || 'Có lỗi khi tải hỗ trợ phần mềm cá nhân';
      });
  },
});

export const { clearNhiemVuCaNhanState } = nhiemVuCaNhanSlice.actions;
export default nhiemVuCaNhanSlice;
